// AppHeader.jsx
import React from "react";

const Header = () => {
  return (
    <header className="border-bottom mb-4" style={{ backgroundColor: "#ffffffff" }}>
      <nav className="navbar navbar-expand navbar-light px-3">
        {/* Marca / título */}
        <div className="navbar-brand d-flex align-items-center">
          <span className="fw-bold">SECTOR BXII</span>
          <span className="text-muted ms-2">Área de Gestión</span>
        </div>


      </nav>
    </header>
  );
};

export default Header;
